import { render, staticRenderFns } from "./RegisterForm.vue?vue&type=template&id=540d2a70&scoped=true&"
import script from "./RegisterForm.vue?vue&type=script&lang=ts&"
export * from "./RegisterForm.vue?vue&type=script&lang=ts&"
import style0 from "./RegisterForm.vue?vue&type=style&index=0&id=540d2a70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "540d2a70",
  null
  
)

export default component.exports